var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.285083 1.53211C0.733333 0.627364 1.66742 0.00219727 2.75 0.00219727H19.25C20.3326 0.00219727 21.2667 0.627364 21.7149 1.53211C21.8973 1.90061 22 2.31586 22 2.7522V11.9189C22 13.4378 20.7689 14.6689 19.25 14.6689H2.75C1.23108 14.6689 0 13.4378 0 11.9189V2.7522C0 2.31586 0.102667 1.90061 0.285083 1.53211ZM2.83064 1.83553L10.5609 6.0522C10.835 6.20161 11.165 6.20161 11.4391 6.0522L19.1693 1.83553H2.83064ZM20.1667 3.38013L12.3173 7.66096C11.4959 8.10921 10.5041 8.10921 9.68275 7.66096L1.83333 3.38013V11.9189C1.83333 12.4249 2.244 12.8355 2.75 12.8355H19.25C19.756 12.8355 20.1667 12.4249 20.1667 11.9189V3.38013Z",
    fill: "#00A3A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailColored);
export default __webpack_public_path__ + "static/media/EmailColored.6c4a3f01f5a2b350a8fb3c39527b7016.svg";
export { ForwardRef as ReactComponent };